export default "__VITE_ASSET__BqslpiuO__"